import React from "react"
import { graphql } from "gatsby"
import style from "./simple-card-grid.mod.scss"
import { Card, Container } from "../components"

const SimpleCardGrid = ({ items, layout }) => {
  const classes = [style.cardz]

  layout === "3-wide" && classes.push(`${style.cardz}--3-wide`)

  return (
    <Container>
      <div className={classes.join(" ")}>
        {items.map(item => (
          <Card
            elevated
            image={item.image}
            heading={item.heading}
            content={item.content}
            link={item.link?.link}
            simple
          />
        ))}
      </div>
    </Container>
  )
}

export default SimpleCardGrid

export const query = graphql`
  fragment SimpleCardGrid on DatoCmsSimpleCardGrid {
    id
    __typename
    items {
      id
      image {
        gatsbyImageData(
          layout: FULL_WIDTH
          imgixParams: { h: "620", fit: "crop", w: "1140", q: 60 }
        )
        alt
      }
      heading
      content
      link {
        ...Link
      }
    }
    padding
    layout
    model {
      apiKey
    }
  }
`
